
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscriptionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Subscription"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billing_frequency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bonus_extension_period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancel_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancellation_effective_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"collection_tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ext_subscription_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"founder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hard_failure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_valid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_bill_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_payment_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"next_retry_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offer_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offer_periods"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offer_period_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partner_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patron"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promoted_oven_brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provider"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"renewable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requires_hc_brand_ownership"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscription_plan_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"update_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"used_intro_offer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"used_retention_offer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"voucher_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"voucher_duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"voucher_used_at"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":631}};
    doc.loc.source = {"body":"fragment SubscriptionFields on Subscription {\n  billing_frequency\n  bonus_extension_period\n  cancel_url\n  cancellation_effective_date\n  collection_tags\n  coupon\n  created\n  currency\n  ext_subscription_id\n  expired\n  founder\n  hard_failure\n  id\n  is_valid\n  next_bill_date\n  next_payment_amount\n  next_retry_date\n  offer_amount\n  offer_periods\n  offer_period_unit\n  paid\n  partner_id\n  partner\n  patron\n  promoted_oven_brand\n  provider\n  renewable\n  requires_hc_brand_ownership\n  subscription_plan_id\n  status\n  unit_price\n  update_url\n  used_intro_offer\n  used_retention_offer\n  voucher_code\n  voucher_duration\n  voucher_used_at\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SubscriptionFields"] = oneQuery(doc, "SubscriptionFields");
        
